import { string, bool } from "prop-types"

const InfoMessage = ({ group, attendeeQuestionsUrl, formsUrl, isSimpleEvent }) => {
  if (isSimpleEvent) return null

  if (group === "registrant") {
    return (
      <span>
        Need to collect information from individual attendees? Use{" "}
        <a href={attendeeQuestionsUrl}>attendee questions</a> instead.
      </span>
    )
  } else {
    return (
      <span>
        Need to ask more than 5 questions? Consider using <a href={formsUrl}>a form</a> instead.
      </span>
    )
  }
}

InfoMessage.propTypes = {
  group: string,
  attendeeQuestionsUrl: string,
  formsUrl: string,
  isSimpleEvent: bool
}

export default InfoMessage
